module.exports = __webpack_public_path__ + "img/Feature.d4506e6a.jpg";